import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './dark.css';
import './casa.css'; // Casa Libre design-system override layer (loaded last)
import './utils/axiosAuth'; // global JWT interceptor for all API calls
import { applyTheme } from './utils/theme';

import App from './App';
import reportWebVitals from './reportWebVitals';

// Casa Libre is a light warm theme; dark mode is retired. Force light always.
applyTheme('light');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
